import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { BonusType } from "@gql/offer";
import { Fiat, IVSNFeeTokenCollection } from "@models";
import { Tradable } from "@models/interfaces/tradable";

export interface IVisionSummarySwapTotalComponentInput {
	total: string;
	sourceTradable: Tradable;
	targetTradable: Tradable;
	sourceTotal: string;
	targetTotal: string;
	fiat: Fiat;
	vsnFeeCollection: IVSNFeeTokenCollection;
}

@Component({
	selector: "vision-summary-swap-total-ui",
	templateUrl: "./vision-summary-swap-total.component.html",
	styleUrl: "./vision-summary-swap-total.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class VisionSummarySwapTotalComponent {
	vm = input<IVisionSummarySwapTotalComponentInput>({
		total: "0",
		sourceTradable: null,
		targetTradable: null,
		sourceTotal: "0",
		targetTotal: "0",
		fiat: null,
		vsnFeeCollection: null
	});

	type = BonusType;
}
